export enum DirectionCode {
    N, NE, E, SE, S, SW, W, NW
}